<template>
  <span id="list-filter-menu">
    <v-menu
      :offset-y="true"
      transition="slide-y-transition"
      bottom
      nudge-bottom="5"
    >
      <template v-slot:activator="{ on, attrs, value }">
        <v-btn
          color="primary"
          class="filter-btn"
          v-bind="attrs"
          v-on="on"
        >
          <font-awesome-icon
            :icon="['fas', 'filter']"
          />
          <span>Add Filter</span>
          <font-awesome-icon :icon="value ? 'chevron-up' : 'chevron-down'" />
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="name in filters"
          :key="name"
          ripple
          link
          @click="addFilter(name)"
        >
          <v-list-item-title color="muted">
            <span style="font-size: 1rem; color: #2B394E;">{{ name }}</span>
            <font-awesome-icon
              :icon="['fal', 'plus']"
              color="#535353"
              style="float: right;"
            />
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn
      v-if="selectedFilters.length > 0"
      text
      color="muted"
      class="clear-btn ml-5"
      @click="clearFilters"
    >
      <span class="clear-all-text">clear all</span>
    </v-btn>
  </span>
</template>

<script>
  export default {
    name: 'ListFilterMenu',
    props: {
      filters: Array,
      selectedFilters: Array,
    },
    methods: {
      addFilter (item) {
        this.$emit('add-filter', item)
      },
      clearFilters () {
        this.$emit('clear-filters')
      },
    },
  }
</script>
<style lang="scss">
.clear-all-text {
  color: #456E6C;
}
#list-filter-menu {
  .filter-btn[aria-expanded="false"] {
    &::before {
      opacity: 0;
    }
  }
}
</style>
